import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/helper/constants';
import { IUser, IManager } from 'src/app/models/user';
import { ISearchUser } from 'src/app/models/search-user';

@Injectable({
  providedIn: 'root'
})
export class GraphService {

  constructor(private httpClient: HttpClient) {
    // Do Nothing
  }

  getUserDetails(email): Observable<IUser> {
    return this.httpClient.get<IUser>(Constants.GRAPH_BASE_URL + email + Constants.GRAPH_USER_QUERY);
  }
    getUserDetailsBE(email): Observable<IUser> {
    return this.httpClient.get<IUser>(Constants.getUserDetails + email);
  }

  getUserPhoto(email) {
    return this.httpClient.get(Constants.GRAPH_BASE_URL + email + Constants.GRAPH_PHOTO_QUERY,
      { responseType: 'blob' });
  }

  getUsersFromAlias(searchString): Observable<ISearchUser> {
    return this.httpClient.get<ISearchUser>(Constants.GRAPH_BASE_URL +
      '?$filter=startswith(extension_8b4e685f580748b59864d62c2e7fcfad_sAMAccountName,\'' + searchString + '\')' +
      'or startswith(displayName,\'' + searchString + '\')' +
      'or startswith(extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber,\'' + searchString + '\')' +
      '&$Select=displayname,userPrincipalName,' +
      'givenName, surname,' +
      'extension_8b4e685f580748b59864d62c2e7fcfad_employeeType,' +
      'jobTitle,extension_8b4e685f580748b59864d62c2e7fcfad_employeeNumber,' +
      'extension_8b4e685f580748b59864d62c2e7fcfad_msDS_cloudExtensionAttribute10,' +
      'extension_8b4e685f580748b59864d62c2e7fcfad_msDS_cloudExtensionAttribute6, ' +
      'extension_8b4e685f580748b59864d62c2e7fcfad_sAMAccountName');
  }

  getManagerDetials(email): Observable<IManager> {
    return this.httpClient.get<IManager>(Constants.GRAPH_BASE_URL + email + '/manager' + Constants.GRAPH_MANAGER_QUERY);
  }
}
